@if (showFilter) {
  <div class="cw-flex-row">
    <!-- Loading Icon -->
    @if (loading) {
      <div class="cw-global-loading-icon" [ngClass]="{'cw-global-header-icon': homeEnabled}">
        <span class="cw-global-regionsfilter-icon icon-spinner icon-spin"></span>
      </div>
    }
    <!-- Home Icon -->
    @if (!loading && homeEnabled) {
      <div class="cw-global-header-icon" (click)="toggleOwnRegion()">
        <span class="cw-global-regionsfilter-icon icon-institution"></span>
      </div>
    }
    <div>
      <!-- DEBUG  Division: {{currentDivision}} | Region: {{currentRegion}}-->
      <!-- <button mat-button (click)="resetFilter()"> RESET </button> -->
      <!-- Breadcrumbnavigation-Buttons: öffnen Regionsmenü for="regionsfilter1"
      *ngif="{{showFilter}}"-->
      <!-- 2019-07-04, Phs(MFe): Dirty hack, ngStyle damit Schriftfarbe DFKC auch im disabled-Status weiß bleibt -->
      <button
        mat-button
        class="cw-breadcrumb"
        [ngClass]="{'cw-breadcrumb-start': homeEnabled}"
        [matMenuTriggerFor]="regionsfilter1"
        (click)="openRegionsfilter(0)"
        [disabled]="onlyOwnRegion && !(onlyOwnDivisionEvents && currentModule === 'events')"
        [ngStyle]="{color: '#fff'}">
        {{ filterLabel1 }}
      </button>
      <button
        mat-button
        [ngClass]="globalRegionsfilterLevels == 1 ? 'cw-breadcrumb cw-breadcrumb-end' : 'cw-breadcrumb'"
        [matMenuTriggerFor]="regionsfilter1"
        (click)="openRegionsfilter(1)"
        [disabled]="onlyOwnRegion && !(onlyOwnDivisionEvents && currentModule === 'events')"
        [ngStyle]="{color: '#fff'}">
        {{ filterLabel2 }}
      </button>
      @if (globalRegionsfilterLevels == 2) {
        <button
          mat-button
          class="cw-breadcrumb cw-breadcrumb-end"
          [matMenuTriggerFor]="regionsfilter1"
          (click)="openRegionsfilter(2)"
          [ngStyle]="{color: '#fff'}"
          [disabled]="onlyOwnRegion && !(onlyOwnDivisionEvents && currentModule === 'events')">
          {{ filterLabel3 }}
        </button>
      }
      <!-- Aufgeklappter Regionsfilter -->
      <mat-menu #regionsfilter1="matMenu" yPosition="below" [overlapTrigger]="false">
        @if (totalAllowed) {
          <button mat-button color="primary" class="reset-button" (click)="resetFilter()">
            {{ 'GLOBAL.REGIONSFILTER.TOTAL' | translate }}
          </button>
        }
        <mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
          <!-- Unterste Ebene (kann nicht mehr aufgeklappt werden) matTreeNodeToggle-->
          <mat-tree-node
            *matTreeNodeDef="let node"
            matTreeNodePadding
            matTreeNodePaddingIndent="25"
            (click)="clickRegionsfilter(node)">
            {{ node.name }}
          </mat-tree-node>
          <!-- Alle aufklappbaren Ebenen matTreeNodeToggle-->
          <mat-tree-node
            *matTreeNodeDef="let node; when: hasChild"
            matTreeNodePadding
            matTreeNodePaddingIndent="15"
            (click)="clickRegionsfilter(node)"
            [attr.aria-label]="'toggle ' + node.name">
            <button
              mat-icon-button
              small-icon-button
              matTreeNodeToggle
              [attr.aria-label]="'toggle ' + node.name">
              <mat-icon class="mat-icon-rtl-mirror">
                <fa-icon [icon]="treeControl.isExpanded(node) ? 'chevron-down' : 'chevron-right'"></fa-icon>
              </mat-icon>
            </button>
            {{ node.name }}
          </mat-tree-node>
        </mat-tree>
      </mat-menu>
    </div>
  </div>
}
